/* eslint-disable camelcase */
import { call, select, takeLatest, put } from 'redux-saga/effects'
import { get, uniq, values } from 'lodash-es'
import axios from 'axios'
import { selectUser } from './user'
import { makeGetAllUserIds } from './entities'
import { normalize } from 'normalizr'

import { user as userSchema } from '../schemas'

import API from '../config'
import { getHeaders } from './api'

// ------------------------------------
// Constants
// ------------------------------------

const rootApi = `${API.apiPath}/${API.apiVersion}/`

const REQUEST_USER_DATA = 'REQUEST_USER_DATA'
export const RECEIVE_USER_DATA = 'RECEIVE_USER_DATA'

// ------------------------------------
// Actions
/* ------------------------------------ */

export const requestUserData = payload => {
  return {
    type: REQUEST_USER_DATA,
    payload
  }
}

const receiveUserData = data => ({
  type: RECEIVE_USER_DATA,
  payload: { data }
})

function* processUserData(action) {
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const getUserIds = makeGetAllUserIds()
  const fetchedIds = yield select(getState => getUserIds(getState))
  const ids = uniq(
    values(action.payload || {}).reduce((accumulator, currentValue) => {
      accumulator = accumulator.concat(currentValue.userIds)
      return accumulator
    }, [])
  )
    .filter(i => !fetchedIds.includes(i))
    .join(',')
  if (ids) {
    const response = yield call([axios, 'get'], `${rootApi}account/users-data`, {
      headers: getHeaders(token),
      params: {
        ids
      }
    })
    const normalizedData = normalize(response.data.users, [userSchema])
    yield put(receiveUserData(normalizedData))
  }
}

export function* processUserDataSaga() {
  yield takeLatest(REQUEST_USER_DATA, processUserData)
}
